/**
 * Shared shapes for the two-phase upload pipelines (contracts + KYC).
 *
 * Centralised here so the contract path (`contracts.service.ts`) and
 * the workflow KYC path (`workflow.service.ts`) emit the same event
 * shape and accept the same cancellation token — the UI components
 * (`ContractDocumentUpload`, `DynamicField`) can render identical
 * "Uploading X% · Y MB remaining" copy + Cancel button without
 * branching on which service produced the event.
 *
 * `fraction` is a 0..1 ratio so callers can drive a progress bar
 * directly; `loaded` / `total` are raw bytes so the UI can render
 * a "remaining" string without re-computing.
 */
export interface UploadProgress {
  fraction: number;   // 0..1
  loaded: number;     // bytes uploaded so far
  total: number;      // bytes in the file
}

/** Convert raw bytes to a short human label ("2.1 MB", "640 KB"). */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
  return `${(bytes / 1024 / 1024 / 1024).toFixed(2)} GB`;
}
